<template>
  <div id="app" class="page-component__scroll">
    <el-scrollbar class="scrollbar">
    <router-view />
    </el-scrollbar>
    <el-backtop target=".page-component__scroll .el-scrollbar__wrap" :bottom="100" :visibility-height="50"> 
      <div style="{
        height: 45px;
        width: 45px;
        border-radius: 50%;
        background-color: #000;
        text-align: center;
        color: #fff;
        opacity: 0.3;
        font-size: 14px;
        
      }"
    >
    <i class="el-icon-arrow-up"></i>
      TOP
    </div></el-backtop>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  
  overflow-x: hidden;
}

#app {
  @font-face {
    font-family: 'PingFangSC-Regular'; 
    src: url('/assets/font/PingFangSC-Regular.ttf');
    font-weight: normal;
    font-style: normal;
  }
  //font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: "PingFangSC-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #ffffff;
}
.app {
  height: 100vh;
  overflow-x: hidden;
}
.scrollbar {
  height: calc(100vh);
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
